/**
 * @ngdoc service
 * @name ModelApp:InitModelFactory
 *
 * @description
 *
 *
 * */
/* @ngInject */
export default function DefinitionModelService($location, $translate, $q, AllDefinitionsCacheService, CacheService, DefinitionApiService, NotifyingService,
                                               UniquePartApiService, ImageProcessorService, SpinnerLoadingService, __env) {
    let Init = {};

    function cacheDefinition(definitions, definitionId) {
        for (var i = 0; i < definitions.length; i++) {
            // Type coercion is needed in this case, since definitionId is a string
            if (definitions[i].id == definitionId) {
                CacheService.storeDefinition(definitions[i]);
                break;
            }
        }
    }

    Init.findDefinition = function (definition, definitions) {
        for (var i = 0; i < definitions.length; ++i) {
            if (definition.id === definitions[i].id) {
                return definitions[i];
            }
        }
        return undefined;
    };

    Init.setProperties = function () {
        var definitions = CacheService.getAllDefinitions();

        for (var i = 0; i < definitions.length; i++) {
            AllDefinitionsCacheService.setDefinitionParamRange(definitions[i]);
        }
    };

    Init.findCurrentDefinition = function (parents) {
        var rootDefinitions = CacheService.getAllDefinitions();
        for (var i = 0; i < parents.length; ++i) {
            parents[i] = Init.findDefinition(parents[i], rootDefinitions);
            rootDefinitions = parents[i].childDefinitions;
        }
        return rootDefinitions;
    };

    Init.populateParentDefinition = function (parents) {
        CacheService.getParentDefinition().length = 0;
        var definitions = CacheService.getAllDefinitions();
        for (var i = 0; i < parents.length; ++i) {
            for (var j = 0; j < definitions.length; ++j) {
                if (parents[i].id === definitions[j].id) {
                    CacheService.storeParentDefinition(definitions[j]);
                    definitions = definitions[j].childDefinitions;
                    break;
                }
            }
        }
    };

    Init.getParentsById = function (definitionId, callback) {
        DefinitionApiService.getAncestorsByDefinitionId(definitionId, function (parents) {
            parents.reverse();
            Init.populateParentDefinition(parents);
            // CacheService.restoreParentDefinition(parents);
            callback(definitionId, parents);
        });
    };

    Init.getCurrentDefinition = function (definitionId, parents) {
        if (parents.length === 0) { // In case definitionId is root definition
            cacheDefinition(CacheService.getAllDefinitions(), definitionId);
        } else {
            var currentDefinitions = Init.findCurrentDefinition(parents);
            cacheDefinition(currentDefinitions, definitionId);
        }
        NotifyingService.notifyModelServiceInit();
    };

    /*
     Untested and unused method
     This method is intended to traverse the whole tree.
     */
    Init.searchDefinitionsForCurrent = function (definitionId, parents) {
        for (var i = 0; parents.childDefinitions.length; i++) {
            if (parents.childDefinitions) {
                Init.searchDefinitionsForCurrent(definitionId, parents.childDefinitions);
            } else {
                for (var j = 0; parents.length; i++) {
                    if (parents.childDefinitions.length > 0) {
                        Init.searchDefinitionsForCurrent(definitionId, parents[j].childDefinitions);
                    }
                    if (parents[j].id === definitionId) {
                        CacheService.storeDefinition(parents[j]);
                        NotifyingService.notifyModelServiceInit();
                    }
                }
            }
        }
    };

    Init.getModelInit = function () {
        SpinnerLoadingService.showLoading();
        var definitionsPromise = AllDefinitionsCacheService.getAllDefinitions();

        // Another way to do it is to chain definitions into the concurrency,
        // but Won said it's a little more dangerous if something fails.
        definitionsPromise
            .then(function (definitions) {
                CacheService.storeAllDefinitions(definitions);

                if ($location.search().search && $location.path() !== '/distributor') {
                    $location.path('/search/' + window.encodeURIComponent($location.search().search));
                }
                // If we detect parameter values id in the url, we still want it to be handle by ExternalSleuthController
                else if ($location.search().parmValueIds && $location.path() !== '/distributor') {
                    $location.path('/search/' + window.encodeURIComponent($location.search().parmValueIds));
                } else if ($location.search().id && $location.path() !== '/distributor') { // distributor shouldn't not have id number
                    Init.getParentsById($location.search().id, Init.getCurrentDefinition);
                } else if ($location.search().pn) { // in case distributor page
                    if ($location.search().search) {
                        CacheService.storeOriginalQueryInput($location.search().search);
                    } else {
                        CacheService.storeOriginalQueryInput($location.search().pn);
                    }
                    UniquePartApiService.getUniquePart($location.search().pn, function (singlePart) {
                        CacheService.storeUniquePart(singlePart);
                        Init.getParentsById(singlePart.leafDefinitionId, Init.getCurrentDefinition);
                    });
                }
            })
            .then(function () {
                var info = {};
                info.language = __env.language;

                ImageProcessorService.processImagesAndDefinitions(null, CacheService.getAllDefinitions());

                Init.setProperties();

                if (info.language === 'ENGLISH') {
                    $translate.use('en');
                } else if (info.language === 'JAPANESE') {
                    $translate.use('jp');
                }

                CacheService.storeConfigurationInfo(info);

                Init.populateDisplayName(CacheService.getAllDefinitions(), CacheService.getConfigurationInfo().language);

                SpinnerLoadingService.hideLoading();

                return NotifyingService.notifyModelServiceInit(); // notify the definitions are done
            })['catch'](function (reason) { // Use bracket to support IE8
            console.error('Model initialization failed due to: ' + reason);
            SpinnerLoadingService.hideLoading();
        });

        SpinnerLoadingService.hideLoading();
    };

    Init.populateDisplayName = function (definitions, language) {
        for (var i = 0; i < definitions.length; ++i) {
            var j;
            switch (language) {
                // Will always have an English version -- or something is very wrong.
                case 'ENGLISH' :
                    for (j = 0; j < definitions[i].displayNames.length; ++j) {
                        if (definitions[i].displayNames[j].language === language
                            && definitions[i].nameBreadcrumbs[j].language === language) {
                            definitions[i].displayName = definitions[i].displayNames[j].display;
                            definitions[i].nameBreadcrumb = definitions[i].nameBreadcrumbs[j].display;
                            break;
                        }
                    }
                    if (definitions[i].childDefinitions.length > 0) {
                        Init.populateDisplayName(definitions[i].childDefinitions, language);
                    }
                    break;
                case 'JAPANESE' :
                    if (definitions[i].displayNames.length > 1) {
                        for (j = 0; j < definitions[i].displayNames.length; ++j) {
                            // Try for a Japanese display name first
                            if (definitions[i].displayNames[j].language === language
                                && definitions[i].nameBreadcrumbs[j].language === language) {
                                definitions[i].displayName = definitions[i].displayNames[j].display;
                                definitions[i].nameBreadcrumb = definitions[i].nameBreadcrumbs[j].display;
                                break;
                            }
                        }
                    } else {
                        // May not always have Japanese language, so just return the english one
                        definitions[i].displayName = definitions[i].displayNames[0].display;
                        definitions[i].nameBreadcrumb = definitions[i].nameBreadcrumbs[0].display;
                    }

                    if (definitions[i].childDefinitions.length > 0) {
                        Init.populateDisplayName(definitions[i].childDefinitions, language);
                    }
                    break;
                default:
                    // Unsupported language default to English. Shouldn't be necessary, though, since it's coming from
                    // the REST API.
                    for (j = 0; j < definitions[i].displayNames.length; ++j) {
                        if (definitions[i].displayNames[j].language === 'ENGLISH'
                            && definitions[i].nameBreadcrumbs[j].language === 'ENGLISH') {
                            definitions[i].displayName = definitions[i].displayNames[j].display;
                            definitions[i].nameBreadcrumb = definitions[i].nameBreadcrumbs[j].display;
                            break;
                        }
                    }
                    if (definitions[i].childDefinitions.length > 0) {
                        Init.populateDisplayName(definitions[i].childDefinitions, language);
                    }
            }
        }
    };

    return Init;
}

